// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XViCXG4_jJ7IHA {
  display: flex;
  flex-flow: row;
  flex-wrap: wrap;
}
.U0xWAXuRraYcmT {
  display: flex;
  justify-content: center;
}
.C5NuxZvV6Rd40Y {
  flex: 1 1 auto;
  min-height: calc(100vh - 80px);
  padding-bottom: 32px;
  background-color: var(--ds-background-accent-gray-subtlest, #f1f2f4);
}
.enmFOd2MKbNNoS {
  display: flex;
  justify-content: center;
  padding: 32px;
}
.ZEJ35GVYAYvo9b {
  font-style: italic;
}
.ssXnfmsGA4aFqK {
  flex-grow: 1;
  min-width: 320px;
  max-width: 800px;
  padding: 32px;
  border: 1px solid var(--ds-border, #091e4224);
  border-radius: 4px;
  background-color: var(--ds-surface, #ffffff);
}
.WmNHi3BqTmzxw0 {
  display: flex;
  align-items: center;
  justify-content: center;
}
.r7rX6zXgrAWHag {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--ds-border, #091e4224);
}
.r7rX6zXgrAWHag .b5PjWKbTGlRGHw {
  margin: 12px 0 0;
}
.JHWMD7JvwGCLvL {
  padding-top: 16px;
  border-top: 1px solid var(--ds-border, #091e4224);
}
.JHWMD7JvwGCLvL button {
  margin-left: 8px;
}
.uM8PuNyLhWE0Qh {
  display: flex;
  justify-content: flex-end;
}
@media only screen and (max-width: 900px) {
  .ssXnfmsGA4aFqK {
    padding: 16px;
  }
}
.hlD9_sF1rMzvro {
  padding-top: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--ds-border, #091e4224);
}
.hlD9_sF1rMzvro .ctjHUkOhVdnMaU {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.hlD9_sF1rMzvro .YfzYkS930fh5b5 {
  margin-top: 8px;
}
.hlD9_sF1rMzvro ._2ErHIkIKWWdZiB {
  display: flex;
  align-items: center;
  margin-top: 8px;
}
.hlD9_sF1rMzvro ._2ErHIkIKWWdZiB a {
  color: var(--ds-text, #172b4d);
}
.hlD9_sF1rMzvro .ksYsEA3iswWOUW {
  margin-right: 8px;
}
.hlD9_sF1rMzvro .JCcVAILWglu0f_ {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: 16px 0 0 60px;
}
.hlD9_sF1rMzvro .JCcVAILWglu0f_ .qfknt3GXJCuz7H {
  min-width: 20px;
  min-height: 20px;
}
.hlD9_sF1rMzvro .JCcVAILWglu0f_ .HwA4UVjatYvz6g {
  margin: 0 60px 0 16px;
}
.hlD9_sF1rMzvro .JCcVAILWglu0f_ .HwA4UVjatYvz6g h3 {
  margin-bottom: 4px;
}
.hlD9_sF1rMzvro .JCcVAILWglu0f_ .HwA4UVjatYvz6g p {
  font-size: 13px;
  line-height: 20px;
}
.hlD9_sF1rMzvro .JCcVAILWglu0f_ .HwA4UVjatYvz6g p a {
  font-weight: bold;
}
@media only screen and (max-width: 900px) {
  .hlD9_sF1rMzvro .JCcVAILWglu0f_ {
    margin-left: 20px;
  }
  .hlD9_sF1rMzvro .JCcVAILWglu0f_ .HwA4UVjatYvz6g {
    margin-right: 20px;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flexRowWrap": `XViCXG4_jJ7IHA`,
	"flexAndCenter": `U0xWAXuRraYcmT`,
	"body": `C5NuxZvV6Rd40Y`,
	"navigationAndContent": `enmFOd2MKbNNoS`,
	"learnMoreSubtle": `ZEJ35GVYAYvo9b`,
	"content": `ssXnfmsGA4aFqK`,
	"spinnerContainer": `WmNHi3BqTmzxw0`,
	"header": `r7rX6zXgrAWHag`,
	"title": `b5PjWKbTGlRGHw`,
	"footer": `JHWMD7JvwGCLvL`,
	"formFooter": `uM8PuNyLhWE0Qh`,
	"capabilitySection": `hlD9_sF1rMzvro`,
	"nameAndToggle": `ctjHUkOhVdnMaU`,
	"description": `YfzYkS930fh5b5`,
	"learnMore": `_2ErHIkIKWWdZiB`,
	"infoIcon": `ksYsEA3iswWOUW`,
	"capabilitiesOptions": `JCcVAILWglu0f_`,
	"gearIcon": `qfknt3GXJCuz7H`,
	"nameAndDescription": `HwA4UVjatYvz6g`
};
export default ___CSS_LOADER_EXPORT___;
